
const initialState = {
  folderPath: '',
  tagsSelected: [],
  list: [],
};

function tagKey(o) {
  if (o == null) return '';
  return typeof o === 'object' && o.id != null ? String(o.id) : String(o);
}

function tagsSelectedMatch(requestTags, stateTags) {
  const a = requestTags || [];
  const b = stateTags || [];
  if (a.length !== b.length) return false;
  const sortStr = (x, y) => x.localeCompare(y);
  const sa = [...a.map(tagKey)].sort(sortStr);
  const sb = [...b.map(tagKey)].sort(sortStr);
  return sa.every((v, i) => sb[i] === v);
}

// eslint-disable-next-line
export default (state = initialState, { type, payload, args }) => {
  switch (type) {
    case '@contracting_workspace_list/getList_SUCCESS': {
      const requestTags = args?.[0]?.tagsSelected;
      if (requestTags != null && !tagsSelectedMatch(requestTags, state.tagsSelected)) {
        return state;
      }
      return {
        ...state,
        list: payload,
      };
    }
    case '@contracting_workspace_list/openFolder':
      return {
        ...state,
        ...payload,
      };
    case '@contracting/updateWorkspaceContract_SUCCESS':
      return {
        ...state,
        list: state.list.map(o => {
          if (args?.[0]?.docIds && args[0].docIds.indexOf(o._id) > -1) {
            return { ...o, ...args[0].updater };
          }
          return o;
        }),
      };
    case '@contracting_workspace_list/removeFilters':
      return {
        ...state,
        folderPath: '',
        tagsSelected: [],
      };
    case '@contracting_workspace_list/updateTagsSelected':
      return {
        ...state,
        tagsSelected: payload,
      };
    case '@contracting_workspace_sendRequest/send_SUCCESS':
      return {
        ...state,
        list: state.list.map(l => {
          if (args?.[0]?.contractId && l._id === args[0].contractId) return { ...l, lastSent: new Date().toISOString() };
          return l;
        }),
      };
    default:
      return state;
  }
};
